/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Select_Profile_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Select a profile" |
*
* @param {Editor_Select_Profile_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_select_profile_placeholder = /** @type {((inputs?: Editor_Select_Profile_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Select_Profile_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionnez un profil")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie ein Profil aus")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un profilo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите профиль")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un perfil")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择个人资料")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロフィールを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक प्रोफ़ाइल चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um perfil")
	return /** @type {LocalizedString} */ ("Select a profile")
});